import React, { useState, useEffect } from 'react';

/** Plugins */
import { useDispatch } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton, Button, TextField } from '@material-ui/core';

/** Helpers */
import { showAlert } from '../../store/ducks/alert';
import Languages from '../../constants/categoryLanguages';

/** Services */
import { createCategory, updateCategory } from '../../services/categories';

const CategoryModal = ({ onClose, formData, isUpdating = false }) => {
  const dispatch = useDispatch();
  const [newCategory, setNewCategory] = useState({ name: '', internationalizationLanguage: {} });

  useEffect(() => {
    if (formData) setNewCategory(formData);
  }, [formData]);

  const createNewCategory = async () => {
    try {
      if (isUpdating) return;
      await createCategory(newCategory.name, newCategory.internationalizationLanguage);

      dispatch(showAlert('success', 'Category has been created! 🔥'));
      window.location = '/categories';
    } catch (error) {
      dispatch(showAlert('error', 'Error! We could not register this new category. 😔'));
    }
  };

  const handleUpdateCategory = async () => {
    try {
      await updateCategory(newCategory.id, newCategory.name, newCategory.internationalizationLanguage);

      dispatch(showAlert('success', 'Category has been updated! 🔥'));
      window.location = '/categories';
    } catch (error) {
      dispatch(showAlert('error', 'Error! We could not update this category. 😔'));
    }
  };
  const handleKeyPress = event => {
    if (event.key == 'Escape') onClose();
    if (event.key == 'Enter') {
      if (isUpdating) {
        handleUpdateCategory();
      } else createNewCategory();
    }
  };

  return (
    <div className="category-container">
      <div className="category-container__top">
        <h2> Create or update category</h2>

        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <div>
        <div>
          <form noValidate autoComplete="off">
            <div>
              <TextField
                id="standard-basic"
                label="Category name"
                value={newCategory.name}
                onChange={e => setNewCategory({ ...newCategory, name: e.target.value })}
              />
            </div>
            {Languages.map(language => {
              return (
                <TextField
                  key={language.code}
                  id="standard-basic"
                  value={newCategory.internationalizationLanguage[language.code] || ''}
                  label={`Name in ${language.name}`}
                  onKeyDown={event => handleKeyPress(event)}
                  onChange={e =>
                    setNewCategory({
                      ...newCategory,
                      internationalizationLanguage: { ...newCategory.internationalizationLanguage, [language.code]: e.target.value },
                    })
                  }
                />
              );
            })}
          </form>
        </div>
      </div>
      <Button onClick={isUpdating ? handleUpdateCategory : createNewCategory} variant="contained" className="modal__btn">
        Confirm
      </Button>
    </div>
  );
};
export default CategoryModal;
